var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"d-flex",attrs:{"outlined":""}},[_c('div',{staticClass:"d-flex flex-column"},[_c('v-subheader',[_vm._v(_vm._s(_vm.name))]),_c('h1',{staticClass:"pa-4 pt-0"},[_vm._v(_vm._s(_vm.value))])],1),_c('v-spacer'),_c('v-icon',{staticClass:"mr-4",attrs:{"large":""}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }